import * as React from 'react'

// context
import { useStreamContext } from "../../context"

// rsuite
import { useToaster } from 'rsuite'

// libs
import moment from 'moment'
import uuid from 'short-uuid'

// types
import { CommandsListItem } from '../../context/useStreamContext/types'
import { EmitOptions } from '../types'

// rsuite
import { Notification } from 'rsuite'

// components
import JsonView from '../../components/JsonView'


export default function useEmitSave() {

  // context
  const streamContext = useStreamContext()

  // hooks
  const toaster = useToaster();

  const cls = new class {
    save(type: 'ui' | 'sys', payload: object, options?: EmitOptions) {

      // Save to context store
      const newPayload: CommandsListItem = {
        type,
        uuid: uuid.generate(),
        date: moment.utc().format(),
        payload,
      }

      streamContext.addCommand(newPayload)

      // Check if debug mode enabled or parament specified in emit
      const showNotification = (() => {
        if (typeof options?.debug === 'boolean') {
          return options.debug
        }

        return streamContext.state.playerConfig.debugMode
      })()

      if (showNotification) {
        toaster.push((
          <Notification type="success" header="Command" closable>
            <JsonView data={newPayload} />
          </Notification>
        ), {
          placement: options?.placement || 'bottomEnd',
          duration: options?.duration || 1000 * 2,
        })
      }
    }
  }

  return cls
}